import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

import firebase from "firebase";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "/open",
          name: "open",
          component: () => 
            import("./views/tables/Open.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/closed",
          name: "closed",
          component: () => 
            import("./views/tables/Closed.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/customers",
          name: "customers",
          component: () => 
            import("./views/tables/Customers.vue"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue")
    },

    {
      path: "/add-order",
      name: "add-order",
      component: () =>
        import("./views/open/AddOrder.vue")
    },

    {
      path: "/add-business",
      name: "addbusiness",
      component: () =>
        import("./views/AddBusinessName.vue")
    },

    {
      path: "/subscription",
      name: "subscription",
      component: () =>
        import("./views/subscription/SubPlan.vue")
    },

    {
      path: "/settings",
      name: "settings",
      component: () =>
        import("./views/settings/Settings.vue")
    },

    {
      path: "/texts-finished",
      name: "textsFinished",
      component: () =>
        import("./views/texts-finished/TextsFinished.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // if user isn't logged in
    if (!firebase.auth().currentUser) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // user signed in
      next();
    }
  } else {
    next();
  }
});

export default router;
